import { Component, Input, OnInit, OnChanges, SimpleChanges  } from '@angular/core';
import { Router, ActivatedRoute, Params, ParamMap } from '@angular/router';

import { Globals } from 'src/app/shared/globals';


//import * as _ from 'lodash';

//import { Programme } from '../peppi-lum/programme';
//import { TextService } from '../shared/text.service';
//import { LocalizedString } from '../course/localized-string';
// import { MarkdownService } from 'ngx-md';


@Component({
  selector: 'programme-unit-mobile',
  styleUrls: ['../programme.component.css'],
  template: `
  <div *ngFor="let unit of units">

        <div *ngIf="includesLearningPath(unit)" [ngClass]="{'study-module': unit.type === 'STUDY_MODULE', 'programme-item offering': unit.type === 'OFFERING',
        'category': unit.type === 'CATEGORY', 'programme-item course-unit': unit.type === 'COURSE_UNIT'}">

        <div class="programme-item" [ngClass]="{
          'study-module-item': unit.type === 'STUDY_MODULE',
          'offering-item': unit.type === 'OFFERING',
          'category-item': unit.type === 'CATEGORY',
          'course-unit-item': unit.type === 'COURSE_UNIT'}">

            <div *ngIf="creditPoints" class="programme-item-elem" [ngClass]="{
              'study-module-item': unit.type === 'STUDY_MODULE',
              'offering-item': unit.type === 'OFFERING',
              'category-item': unit.type === 'CATEGORY',
              'course-unit-item': unit.type === 'COURSE_UNIT'}">

              <a *ngIf="unit?.type === 'STUDY_MODULE'"
              routerLink="/{{globals.lang}}/{{globals.getLocalizedStudyModule()}}/{{unit?.code}}/{{unit?.id}}" [queryParams]="{period: period}">
                <span *ngIf="unit.maxCredits!=unit.minCredits"> {{globals.getLocalizedValueForTitle(unit.name)}}, {{unit.minCredits}}-{{unit.maxCredits}} </span>
                <span *ngIf="unit.maxCredits==unit.minCredits"> {{globals.getLocalizedValueForTitle(unit.name)}}, {{unit.minCredits}} </span>
                <span>{{globals.getLocalizedValue(creditPoints)}}</span>
              </a>

              <a *ngIf="unit?.type === 'CATEGORY'"
              routerLink="/{{globals.lang}}/{{globals.getLocalizedCategory()}}/{{unit?.code}}/{{unit?.id}}" [queryParams]="{period: period}">
                <span *ngIf="unit.maxCredits!=unit.minCredits"> {{globals.getLocalizedValueForTitle(unit.name)}}, {{unit.minCredits}}-{{unit.maxCredits}} </span>
                <span *ngIf="unit.maxCredits==unit.minCredits"> {{globals.getLocalizedValueForTitle(unit.name)}}, {{unit.minCredits}} </span>
                <span>{{globals.getLocalizedValue(creditPoints)}}</span>
              </a>

              <a *ngIf="unit?.type === 'OFFERING'"
              routerLink="/{{globals.lang}}/{{globals.getLocalizedOffering()}}/{{unit?.code}}/{{unit?.id}}" [queryParams]="{period: period}">
                <span *ngIf="unit.maxCredits!=unit.minCredits"> {{globals.getLocalizedValueForTitle(unit.name)}}, {{unit.minCredits}}-{{unit.maxCredits}} </span>
                <span *ngIf="unit.maxCredits==unit.minCredits"> {{globals.getLocalizedValueForTitle(unit.name)}}, {{unit.minCredits}} </span>
                <span>{{globals.getLocalizedValue(creditPoints)}}</span>
              </a>

              <a *ngIf="unit?.type === 'COURSE_UNIT'"
              routerLink="/{{globals.lang}}/{{globals.getLocalizedCourse()}}/{{unit?.code}}/{{unit?.id}}" [queryParams]="{period: period}">
                <span *ngIf="unit.maxCredits!=unit.minCredits"> {{globals.getLocalizedValueForTitle(unit.name)}}, {{unit.minCredits}}-{{unit.maxCredits}} </span>
                <span *ngIf="unit.maxCredits==unit.minCredits"> {{globals.getLocalizedValueForTitle(unit.name)}}, {{unit.minCredits}} </span>
                <span>{{globals.getLocalizedValue(creditPoints)}}</span>
              </a>
              <span *ngIf="this.selection === 1">
                <span *ngFor="let plan of unit?.accomplishmentPlanYearList; let i = index">
                  <span *ngIf="plan > 0">
                    <span>,</span><span class="plan">{{i+1}}.{{globals.getAcademicYear()}}</span>
                  </span>
                </span>
              </span>

              <span *ngIf="this.selection === 2">
                <span *ngFor="let plan of unit?.accomplishmentPlanSemesterList; let i = index">
                  <span *ngIf="plan > 0">
                    <span>, </span><span class="plan"> {{ roundUp(((i + 1) / 2), 1) }}.{{ (i + startSemester) % 2 === 0 ? globals.getAutumn() : globals.getSpring() }}</span>
                  </span>
                </span>
              </span>

              <span *ngIf="this.selection === 3">
                <!--<span *ngFor="let plan of filterAccomplishmentPlanPeriodList(unit?.accomplishmentPlanPeriodList); let i = index">
                  <span *ngIf="plan > 0">
                    <span>, </span><span class="plan">{{i+1}}.p</span>
                  </span>
                </span>-->
                <span *ngFor="let plan of filterAccomplishmentPlanPeriodList(unit?.accomplishmentPlanPeriodList); let i = index">
                  <span *ngIf="plan > 0">
                      <span>, </span><span class="plan">{{ getPeriodNumber(i, unit?.accomplishmentPlanPeriodList) }}.p</span>
                  </span>
              </span>


              </span>

              <span class="teached-in-english" *ngIf="globals.lang==='en' && unit?.teachedInEnglish">(in English)</span>
              

            </div>

           <!-- <div class="programme-item-elem" [ngClass]="{
              'study-module-centered': unit.type === 'STUDY_MODULE',
              'offering-centered': unit.type === 'OFFERING',
              'category-centered': unit.type === 'CATEGORY',
              'course-unit-centered': unit.type === 'COURSE_UNIT'}">
              {{unit.minCredits}}</div>-->
            <div>
          </div>

        </div>

        <programme-unit-mobile [unit]="unit.children" [selection]="this.selection" [creditPoints]="this.creditPoints" [year]="this.selectedSchoolYear" [learning-path]="this.learningPath" [period]="this.period" [period-count]="this.periodCount" [start-semester]="this.startSemester" [duration]="this.duration">
        </programme-unit-mobile>

  </div>
      `
})
export class ProgrammeUnitMobileComponent implements OnInit {
@Input('unit') units: any;
@Input('selection') selection: any;
@Input() creditPoints: any;
@Input('year') selectedSchoolYear: any;
@Input('learning-path') learningPath : any;
@Input('period') period: any;
@Input('period-count') periodCount: any;
@Input('start-semester') startSemester!: number;
@Input('duration') duration!: number;
// creditPoints: LocalizedString;
// creditPoints =  {valueFi: 'op', valueEn: 'ETCS', valueSv: ''};
errorMessage: any;

constructor(
  public globals: Globals,
  //private textService: TextService
) {}

ngOnInit(): void {
  /*this.textService.getText('credit.points').subscribe(
    value => this.creditPoints = value,
    error => this.errorMessage = <any>error
  );*/
}


filterAccomplishmentPlanSemesterList(accomplishmentPlanSemesterList: any) {
  return accomplishmentPlanSemesterList.slice(this.selectedSchoolYear - 1, accomplishmentPlanSemesterList.length);
}
filterAccomplishmentPlanList(accomplishmentPlanList: any) {
  return accomplishmentPlanList.slice(this.selectedSchoolYear - 1, accomplishmentPlanList.length);
}
/*filterAccomplishmentPlanPeriodList(accomplishmentPlanPeriodList: any) {
  return accomplishmentPlanPeriodList.slice((this.selectedSchoolYear * 5 - 5), this.selectedSchoolYear * 5);
}*/
filterAccomplishmentPlanPeriodList(accomplishmentPlanPeriodList: any) {
  const totalPeriods = accomplishmentPlanPeriodList.length;
  const periodsPerYear = Math.round(totalPeriods / this.duration);
  const offset = this.startSemester * Math.floor(periodsPerYear / 2);
  const firstYearPeriods = periodsPerYear - offset;

  let start: number;
  let end: number;

  if (this.selectedSchoolYear === 1) {
      start = 0;
      end = firstYearPeriods;
  } else {
      start = firstYearPeriods + (this.selectedSchoolYear - 2) * periodsPerYear;
      end = start + periodsPerYear;
  }
  return accomplishmentPlanPeriodList.slice(start, end);
}

getPeriodNumber(i: number, accomplishmentPlanPeriodList: any): number {
    const totalPeriods = accomplishmentPlanPeriodList.length;
    const periodsPerYear = Math.round(totalPeriods / this.duration);
    const offset = this.startSemester * Math.floor(periodsPerYear / 2);
    const firstYearPeriods = periodsPerYear - offset;

    let globalIndex: number;
    if (this.selectedSchoolYear === 1) {
        globalIndex = i;
    } else {
        globalIndex = firstYearPeriods + (this.selectedSchoolYear - 2) * periodsPerYear + i;
    }

    return ((globalIndex + offset) % periodsPerYear) + 1;
}

   includesLearningPath(unit: any) {
    // palautetaan true, jos ei opintopolkuja valu
    return this.learningPath ? unit.learningPathIds.includes(this.learningPath) : true;
  }

    // precision is 10 for 10ths, 100 for 100ths, etc.
    roundUp(num: any, precision: any) {
      return Math.ceil(num * precision) / precision
    }

}
